module.exports = __webpack_public_path__ + "static/img/detect08.1950713.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect08.png
// module id = 582
// module chunks = 4